export const Check = () => {
  return (
    <iframe
      src={`${process.env.PUBLIC_URL}/opt_landing/index.html`}
      style={{ width: "100%", height: "100vh", border: "none" }}
      title="Opt landing"
    />
  );
};
